// extracted by mini-css-extract-plugin
export default {"errorTitle":"error-title--h0993sxwZgrzd5OxmMgT","errorSubTitle":"error-sub-title--tmwYAbJKsUDrepA3LSjq"};